import React, { Component } from 'react';
import { connect } from 'react-redux';

import { isDdnyUser } from '../../../../utils/auth';

import ViewSectionElement from './ViewSectionElement';

import styles from './_styles/ViewSectionBlock.module.scss';

const allActionCreators = Object.assign({});

export class ViewSectionDataBlock extends Component {

	dataElements() {		
		if(!this.props.schema || !this.props.product) { return []; }

		const elements = [];
		for(const field of this.props.schema.fields) {
			if(this.props.product[field.apiKey] || this.props.product[field.apiKey] === false) {
				elements.push({
					label: field.label,
					value: this.props.product[field.apiKey],
					product: this.props.product,
					fieldSchema: field,
				});
			} else if(field.variantDisplay && this.props.product?.variants?.length > 0) {
				elements.push({
					label: field.label,
					value: this.props.product[field.apiKey],
					product: this.props.product,
					fieldSchema: field,
					apiData: this.props.apiData,
					apiDataPending: this.props.apiDataPending,
				});
			}
		}
		return elements;
	}
	
	render() {

		const elements = this.dataElements();
		if(elements.length === 0) {
			return null;
		}

		return <div className={`${styles.ViewSectionBlock}`}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>{this.props.schema?.title}</div>
			</div>
			<div className={styles.body}>
				{elements.map((elemProps, i) => {

					if(elemProps.fieldSchema?.hidden) {
						return null;
					}

					if(elemProps.fieldSchema?.showCostOnly && this.props.auth.hideData) {
						return null;
					}

					if(elemProps.fieldSchema?.limited) {
						if(!isDdnyUser({ nyLimited: true })) {
							return null;
						}
					}

					return <div key={i} className={styles.elementWrapper}>
						<ViewSectionElement {...elemProps} />
					</div>
				})}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
	};
}

export default connect(mapStateToProps, allActionCreators)(ViewSectionDataBlock);